import type { SupportedLogLevel } from '@ds/swymkit/utils'
import { Logger as LoggerGeneric } from '@ds/swymkit/utils'

import { isRunningInTest } from '~/features-shared/libs/utils/vitest'

export class Logger extends LoggerGeneric {
  _shouldLog(level: SupportedLogLevel) {
    return super._shouldLog(level) && !isRunningInTest()
  }

  _getScope = (level: SupportedLogLevel) => {
    // eslint-disable-next-line newline-per-chained-call
    return `3DSWYM ${level.toUpperCase().padEnd(5, ' ')}`
  }
}

export const logger = new Logger()
